import { createContext, useContext, useState, useCallback } from "react";

const AIContext = createContext(null);

export function AIProvider({ children }) {
  const [isOpen,      setIsOpen]      = useState(false);
  const [module,      setModule]      = useState("dashboard");
  const [initialMsg,  setInitialMsg]  = useState(null);

  const openAI = useCallback((mod = "dashboard", msg = null) => {
    setModule(mod);
    setInitialMsg(msg);
    setIsOpen(true);
  }, []);

  const closeAI = useCallback(() => setIsOpen(false), []);

  return (
    <AIContext.Provider value={{ isOpen, module, initialMsg, openAI, closeAI }}>
      {children}
    </AIContext.Provider>
  );
}

export function useAI() {
  const ctx = useContext(AIContext);
  if (!ctx) throw new Error("useAI must be used inside AIProvider");
  return ctx;
}
